import React, { useContext, useEffect, lazy } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import CreateAccountPage from "../pages/CreateAccount";
import WelcomePage from "../pages/Welcome";
import { route, RoutePaths } from "./RoutePaths";
import AppContainer from "../components/Layout/AppContainer";
import HeaderComponent from "../components/HeaderComponent";
import { UserContext } from "../context/User/userProvider";
import Changelog from "../pages/Changelog";

const Error404 = lazy(() => import("../pages/Error404"));
const ResetPasswordPage = lazy(() => import("../pages/ResetPassword"));
const VerifyEmailPage = lazy(() => import("../pages/VerifyEmail"));
const PasswordChangedPage = lazy(() => import("../pages/PasswordChanged"));
const RegisterInvitedUserPage = lazy(() => import("../pages/RegisterInvitedUser"));
const ForgotPasswordPage = lazy(() => import("../pages/ForgotPassword"));
const VerifyUserFromEmailPage = lazy(() => import("../pages/VerifyUserFromEmail"));

export default function NonAuthRoutes() {
  const userContext = useContext(UserContext);

  useEffect(() => {
    userContext.clearData();
  }, []);

  return (
    <>
      <HeaderComponent isAuthenticated={false} />
      <Routes>
        <Route path={RoutePaths.welcome} element={<WelcomePage />} />
        <Route
          path="*"
          element={
            <>
              <AppContainer id="app-container">
                <Routes>
                  <Route path={RoutePaths.createAccount} element={<CreateAccountPage />} />
                  <Route path={RoutePaths.error404} element={<Error404 />} />
                  <Route path={RoutePaths.registerInvitedUser} element={<RegisterInvitedUserPage />} />
                  <Route path={RoutePaths.forgotPassword} element={<ForgotPasswordPage />} />
                  <Route path={RoutePaths.resetPassword} element={<ResetPasswordPage />} />
                  <Route path={RoutePaths.verifyEmail} element={<VerifyEmailPage />} />
                  <Route path={RoutePaths.verifyUserFromEmail} element={<VerifyUserFromEmailPage />} />
                  <Route path={RoutePaths.passwordChanged} element={<PasswordChangedPage />} />
                  <Route path={RoutePaths.changelog} element={<Changelog />} />
                  <Route path="*" element={<Navigate replace to={{ pathname: route(RoutePaths.welcome) }} />} />
                </Routes>
              </AppContainer>
            </>
          }
        />
      </Routes>
    </>
  );
}
